import { render, staticRenderFns } from "./SMSConversations.vue?vue&type=template&id=8ea63f36"
import script from "./SMSConversations.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSConversations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports